import React, { useCallback, useState, useRef, useEffect } from 'react';
import 'devextreme/data/odata/store';
import { useHistory } from 'react-router-dom';
import { Button } from 'devextreme-react/button';
import {
  Column,
  DataGrid,
  Scrolling,
  FilterRow,
  FilterPanel,
  HeaderFilter,
  Paging,
  Export,
  Pager,
  ColumnChooser,
  ColumnChooserSearch,
  StateStoring,
  ColumnHeaderFilter,
} from "devextreme-react/data-grid";
import GridLayoutManager from "../gridLayoutCustomization/GridLayoutManager";

import CustomStore from 'devextreme/data/custom_store';
import AccordionReact from 'devextreme-react/accordion';
import { getParameterByName, isNotEmpty } from "../services/DockDoorSchedulingService";
import { connect } from "react-redux";
import data from "../assets/apiRoutes.json";
import SelectBox from 'devextreme-react/select-box';
import TextBox from 'devextreme-react/text-box';
import DateBox from 'devextreme-react/date-box';
import { GetFormatedDateWithTime } from '../common/Utils'
import "./dockdoor.css";
import { createStore } from 'devextreme-aspnet-data-nojquery';
import { GridLayout } from "../common/GridLayout";
import Toolbar, { Item } from "devextreme-react/toolbar";
import '../common/css/searchPage.css';
const transactionTypes = [
  {
    ID: 'A',
    Name: 'ALL',
  },
  {
    ID: 'R',
    Name: 'Receipt',
  },
  {
    ID: 'S',
    Name: 'Shipment',
  }
];
const transactionStatuses = [
  {
    ID: 'O',
    Name: 'ALL',
  },
  {
    ID: 'Scheduled',
    Name: 'Scheduled',
  },
  {
    ID: 'Unscheduled',
    Name: 'Unscheduled',
  },
  {
    ID: 'History',
    Name: 'Shipped History',
  }
];
const searchpanel = [
  {
    ID: 1,
    Title: 'Search Filters'
  }
];
const DockDoorSelection = (props) => {
  const dataGrid = useRef(null);
  var accessToken = props.oidc.user.access_token;
  const history = useHistory();
  const [transactionType, setTransactionType] = useState(transactionTypes[0]);
  const [transactionStatus, setTransactionStatus] = useState(transactionStatuses[0]);
  const [transactionNumber, setTransactionNumber] = useState('');
  const [appointmentDate, setAppointmentDate] = useState('');
  const [delivered, setdeliveredDate] = useState('');
  const [currentLayout, setCurrentLayout] = useState("Default");
  const [gridDataSource, setGridDataSource] = useState(null);
  const [delDateFrom, setdelDateFrom] = useState('');
  const [delDateTo, setdelDateTo] = useState('');
  const [shipperBol, setShipperBol] = useState('');
  const [cust, setcust] = useState('');
  const [carrier, setcarrier] = useState('');
  const [cons, setCons] = useState('');
  const [consigneeAddress, setConsigneeAddress] = useState('');
  const [gridData, setGridData] = useState(null);
  const [defaultPageSize, setDefaultPageSize] = useState(10);
  const [selectedItems, setSelectedItems] = useState([]);
  const [animationDuration, setAnimationDuration] = useState(300);
  const allowedPageSizes = [10, 20, 50, 500, 1000, "all"]
  const [searchPanelStatus, setSearchPanelStatus] = useState(false);
  const gridKey = "c31cd077-2f74-4ea1-aab4-9a204027081a";
  const loadState = useCallback(() => { return GridLayout.sendStorageRequest(gridKey, "GET", accessToken, null, currentLayout); }, [currentLayout]);
  const saveState = useCallback((state) => { GridLayout.sendStorageRequest(gridKey, "POST", accessToken, state, currentLayout); }, [gridKey, currentLayout]);
  const dataSource = createStore({
    key: 'transactionNumber',
    loadParams:
    {
      formselectedStatus: function () {
        return transactionStatus.ID;
      },
      formselectedTransType: function () {
        return transactionType.ID;
      },
      formappointment: function () {
        return GetFormatedDateWithTime(appointmentDate)??"";
      },
      formtransactionNumber: function () {
        return transactionNumber;
      },
      formshipperBol: function () {
        return shipperBol;
      },
      formdelDateFrom: function () {
        return GetFormatedDateWithTime(delDateFrom)??"";
      },
      formdelDateTo: function () {
        return GetFormatedDateWithTime(delDateTo)??"";
      },
      formdelivered: function () {
        return GetFormatedDateWithTime(delivered)??"";
      },
      formcons: function () {
        return cons;
      },
      formconsigneeAddress: function () {
        return consigneeAddress;
      },
      formcust: function () {
        return cust;
      },
      formcarrier: function () {
        return carrier;
      }
    },
    loadUrl: `${window._env_.REACT_APP_APIS}/${data.DockDoor.SearchSelection}`,
    onBeforeSend: (method, ajaxOptions) => {
      ajaxOptions.headers = {
        access_token: accessToken,
        Authorization: `Bearer ${accessToken}`,
      };
    },
  });
  const handleTransactionNumbertChange = (e) => {
    setTransactionNumber(e.value);
  };
  const ondeliveredChanged = useCallback(
    (e) => {
      setdeliveredDate(e.value);
    },
    [setdeliveredDate],
  );
  const oncustChanged = useCallback(
    (e) => {
      setcust(e.value);
    },
    [setcust],
  );
  const oncarrierChanged = useCallback(
    (e) => {
      setcarrier(e.value);
    },
    [setcarrier],
  );
  const ondelDateFromChanged = useCallback(
    (e) => {
      setdelDateFrom(e.value);
    },
    [setdelDateFrom],
  );
  const ondelDateToChanged = useCallback(
    (e) => {
      setdelDateTo(e.value);
    },
    [setdelDateTo],
  );
  const onAppointmentDateChanged = useCallback(
    (e) => {
      setAppointmentDate(e.value);
    },
    [setAppointmentDate],
  );
  const onConsChanged = useCallback(
    (e) => {
      setCons(e.value);
    },
    [setCons],
  );
  const onConsigneeAddressChanged = useCallback(
    (e) => {
      setConsigneeAddress(e.value);
    },
    [setConsigneeAddress],
  );
  const onShipperBolChanged = useCallback(
    (e) => {
      setShipperBol(e.value);
    },
    [setShipperBol],
  );
  const onTransactionTypeChanged = useCallback(
    (e) => {
      setTransactionType(e.value);
    },
    [setTransactionType],
  );
  const onTransactionStatusChanged = useCallback(
    (e) => {
      setTransactionStatus(e.value);
    },
    [setTransactionStatus],
  );
  const selectionChanged = useCallback(
    (e) => {
      let newItems = [...selectedItems];
      e.removedItems.forEach((item) => {
        const index = newItems.indexOf(item);
        if (index >= 0) {
          newItems.splice(index, 1);
        }
      });
      if (e.addedItems.length) {
        newItems = [...newItems, ...e.addedItems];
      }
      setSelectedItems(newItems);
      setSearchPanelStatus((prevStatus) => !prevStatus);
    },
    [selectedItems, setSelectedItems],
  );
  function SchedulingTransaction(data) {
    const id = data;
    history.push(`/scheduleappointment/${id}`);
  }

  function UnSchedulingTransaction(data) {
    const id = data;
    history.push(`/unscheduleappointment/${id}`);
  }

  function handleReset() {
    setTransactionType(transactionTypes[0]);
    setTransactionStatus(transactionStatuses[0]);
    setTransactionNumber('');
    setShipperBol('');
    setCons('');
    setConsigneeAddress('');
    setAppointmentDate(null);
    setdelDateFrom(null);
    setdelDateTo(null);
    setcust('');
    setcarrier('');
    setdeliveredDate(null);
    setGridData([]);
  }

  const handleSearch = async (pageIndex, pageSize) => {
    try {
      setGridData(new CustomStore({
        key: 'transactionNumber',
        load: async (loadOptions) => {
          const paramNames = [
            'skip',
            'take',
            'requireTotalCount',
            'requireGroupCount',
            'sort',
            'filter',
            'totalSummary',
            'group',
            'groupSummary',
          ];
          const queryString = paramNames
            .filter((paramName) => isNotEmpty(loadOptions[paramName]))
            .map((paramName) => `${paramName}=${JSON.stringify(loadOptions[paramName])}`)
            .join('&');
          const skipValue = getParameterByName('skip', queryString);
          const takeValue = getParameterByName('take', queryString);
          const requestData = {
            formselectedStatus: transactionStatus.ID,
            formselectedTransType: transactionType.ID,
            formappointment:  GetFormatedDateWithTime(appointmentDate)??"",
            formtransactionNumber: transactionNumber,
            formshipperBol: shipperBol,
            formdelDateFrom: GetFormatedDateWithTime(delDateFrom)??"", 
           formdelDateTo: GetFormatedDateWithTime(delDateTo)??"", 
           formdelivered: GetFormatedDateWithTime(delivered)??"",
            formcons: cons,
            formconsigneeAddress: consigneeAddress,
            formcust: cust,
            formcarrier: carrier,
            skip: skipValue,
            take: takeValue,
          };
          try {
            const url = `${window._env_.REACT_APP_APIS}/${data.DockDoor.SearchSelection}`;
            const response = await fetch(url, {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                access_token: accessToken,
                Authorization: `Bearer ${accessToken}`,
              },
              body: JSON.stringify(requestData),
            });
            const result = await response.json();
            if (result.totalCount != 0) {
              return {
                data: result.data,
                totalCount: result.totalCount,
              };
            } else {
              return {
                data: [],
                totalCount: 0,
              };
            }

          } catch (err) {
            throw new Error('Data Loading Error' + err);
          }
        }
      }));

    } catch (err) {
      throw new Error('Data Loading Error' + err);
    }
  };
  return (
    <div className="search-page-container">
      <div className="search-page-content">
        <div id="accordion" className="search-page-accordion">
            <AccordionReact
              dataSource={searchpanel}
              collapsible={true}
              multiple={false}
              animationDuration={300}
              selectedItems={selectedItems}
              onSelectionChanged={e => {
                if (e.currentTarget === e.target) {
                  selectionChanged(e, e.target);
                }
              }}
              itemTitleRender={() => (
                <Toolbar className="accordian-toolbar">
                  <Item location="before">
                    <div className="title">
                      <h6
                        style={{
                          color: window._env_.Color2
                        }}
                      >
                        Search Filters
                      </h6>
                    </div>
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={() => handleSearch(0, 10)} text="Search" type="default" />
                  </Item>
                  <Item location="after">
                    <Button className="accordianButton" onClick={handleReset} text="Reset" />
                  </Item>
                </Toolbar>
              )}
              itemRender={(itemProps) => (
                <div style={{ height: '165px', overflowY: 'none' }}>
                  <div className="row">
                    <div className="col-md-3">
                      <SelectBox
                        displayExpr="Name"
                        dataSource={transactionTypes}
                        label="Transaction Type"
                        labelMode='static'
                        stylingMode='outlined'
                        value={transactionType}
                        onValueChanged={onTransactionTypeChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <TextBox
                        className="dx-field-value"
                        label="Trans #"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=""
                        style={{ width: '100%' }}
                        value={transactionNumber}
                        onValueChanged={handleTransactionNumbertChange}
                      />
                    </div>
                    <div className="col-md-3">
                      <TextBox
                        className="dx-field-value"
                        label="Shipper Bol#"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=""
                        style={{ width: '100%' }}
                        value={shipperBol}
                        onValueChanged={onShipperBolChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <SelectBox
                        displayExpr="Name"
                        dataSource={transactionStatuses}
                        label="Status"
                        labelMode='static'
                        stylingMode='outlined'
                        value={transactionStatus}
                        onValueChanged={onTransactionStatusChanged}
                      />
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '10px' }}>
                    <div className="col-md-3">
                      <TextBox
                        className="dx-field-value"
                        label="Consignee"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=""
                        style={{ width: '100%' }}
                        value={cons}
                        onValueChanged={onConsChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <TextBox
                        className="dx-field-value"
                        label="Consignee Address"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=""
                        style={{ width: '100%' }}
                        value={consigneeAddress}
                        onValueChanged={onConsigneeAddressChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <DateBox
                        label="Appointment"
                        labelMode='static'
                        stylingMode='outlined'
                        type="date"
                        value={appointmentDate}
                        onValueChanged={onAppointmentDateChanged}
                      />
                    </div>
                    <div className="col-md-3">
                       <DateBox
                        label="Del. Date From"
                        labelMode='static'
                        stylingMode='outlined'
                        type="date"
                        value={delDateFrom}
                        onValueChanged={ondelDateFromChanged}
                      />  
                    </div>
                  </div>
                  <div className="row" style={{ paddingTop: '10px' }}>
                    <div className="col-md-3">
                     <DateBox
                        label="Del. Date To"
                        labelMode='static'
                        stylingMode='outlined'
                        type="date"
                        value={delDateTo}
                        onValueChanged={ondelDateToChanged}
                      />  
                    </div>
                    <div className="col-md-3">
                      <TextBox
                        label="Cust(CODE)"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=''
                        type="date"
                        value={cust}
                        onValueChanged={oncustChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <TextBox
                        label="Carrier(SCAC)"
                        labelMode='static'
                        stylingMode='outlined'
                        defaultValue=''
                        type="date"
                        value={carrier}
                        onValueChanged={oncarrierChanged}
                      />
                    </div>
                    <div className="col-md-3">
                      <DateBox
                        label="Delivered"
                        labelMode='static'
                        stylingMode='outlined'
                        type="date"
                        value={delivered}
                        onValueChanged={ondeliveredChanged}
                      /> 
                    </div>
                  </div>
                </div>
              )}
              id="accordion-container" className="accordion-height"
            />
        </div>
        <div className="search-page-grid-container">
          <DataGrid

onExporting={(e) => {
          if (window.handleDevExtremeDataGridExport) {
            window.handleDevExtremeDataGridExport(e);
          }
        }}
            ref={dataGrid}
            dataSource={dataSource}
            showBorders={true}
            className="search-page-grid"
            remoteOperations={true}
            allowColumnReordering={true}
            allowColumnResizing={true}
            hoverStateEnabled={true}
            wordWrapEnabled={false}
            columnAutoWidth={true}  // Enable automatic column width calculation
            scrolling={{ mode: "standard" }}
          >


              <FilterRow visible={true} />
              <FilterPanel visible={true} />

              <ColumnChooser
                enabled={true}
                title="Choose Column"
                width={290}
                height={290}
                sortOrder="asc"
              >
                <ColumnChooserSearch
                  enabled={true}
                  editorOptions={{ placeholder: 'Search column' }} />
              </ColumnChooser>
              <ColumnHeaderFilter />
              <Export enabled={true} allowExportSelectedData={true} />
              <Paging defaultPageSize={10} />
              <Pager
                visible={true}
                showPageSizeSelector={true}
                allowedPageSizes={allowedPageSizes}
                showNavigationButtons={true}
              />

              <StateStoring
                enabled={true}
                type="custom"
                customLoad={loadState}
                storageKey={gridKey}
                customSave={saveState}
              />
              <Scrolling rowRenderingMode="virtual" />
              <FilterRow visible={true} />
              <HeaderFilter visible={true} />

              <Scrolling mode="virtual" />

              <Column dataField="appointment" caption="Appointment" dataType="datetime" format="MM/dd/yyyy hh:mm aa">

              </Column>
              <Column dataField="transactionNumber" caption='Transaction Number' >
              </Column>
              <Column dataField="shipperBol" caption='Shipper Bol'>

              </Column>
              <Column dataField="delDateFrom" dataType="date" format="MM/dd/yyyy" caption='Del Date From'>

              </Column>
              <Column dataField="delDateTo" dataType="date" format="MM/dd/yyyy" caption='Del Date To'>

              </Column>
              <Column dataField="cons" visible={false} caption='Cons'>

              </Column>
              <Column dataField="consigneeAddress" visible={false} caption='Consignee Address'>

              </Column>
              <Column dataField="delivered" dataType="date" format="MM/dd/yyyy" caption='Delivered'>

              </Column>
              <Column dataField="cust" visible={false} caption='Cust (CODE)'>

              </Column>
              <Column dataField="carrier" visible={false} caption='Carrier (SCAC)'>

              </Column>

              <Column
                caption='Options'
                alignment='center'
                cellRender={(options) => {
                  const isScheduled = options.data.appointment !== null;
                  return (
                    <Button
                      text={isScheduled ? 'UnSchedule' : 'Schedule'}
                      type={isScheduled ? 'default' : 'success'}
                      width={100}
                      onClick={() => isScheduled
                        ? UnSchedulingTransaction(options.data.transactionNumber)
                        : SchedulingTransaction(options.data.transactionNumber)}
                    />
                  );
                }}
              />
              <Toolbar>
                <Item location="after">
                  <GridLayoutManager gridKey={gridKey} dataGrid={dataGrid} setCurrentLayout={setCurrentLayout} />
                </Item>
              </Toolbar>
          </DataGrid>
        </div>
      </div>
    </div>
  );
};

function mapStateToProps(state) {
  return {
    ReceiptReducer: state.ReceiptReducer,
    oidc: state.oidc,
  };
}
export default connect(mapStateToProps)(DockDoorSelection);
